export default class StripeConnectSetupIntentRequestData {
}
